// Enum for comparing roles returned from store.
export enum Roles {
    Admin = "Administrator",
    Requisitioner = "Requisitioner",
    Buyer1 = "Buyer1",
    Buyer2 = "Buyer2",
    Buyer3 = "Buyer3",
    AD = "Architects & Designers",
    Accounting = "AccountingUser_BilltrustOnly",
}

export enum LeadOption{
    Customer = "CUSTOMER",
    PotentialCustomer = "POTENTIAL CUSTOMER",
    Designer = "DESIGNER",
    Architect = "ARCHITECT",
}